export const generalConsts = {

    application: {
        dialogs: {
            type: {
                confirmation: 'confirmation',
                new: 'new',
                edit: 'edit',
                view: 'view',
            },
            actionsAfterClose: {
                refresh: 'refresh',
                edit: 'edit',
            }
        },
        alerts: {

        },
        components: {
            fileUpload: {
                unsupportedCopyPasteMethod: 'Esse método de cópia de arquivos ainda não é suportado, tente tirar um print ou copiar o arquivo físico..',
                unsupportedContent: 'Tipo de conteúdo copiado não suportado.',
                errorConvertImage: 'Erro ao converter a imagem:',
                noImageInClipboard: 'Nenhuma imagem encontrada no conteúdo copiado.',
                inProcess: 'Anexo em processamento',
            }
        },
        export: {
            types: {
                xlsx: 'xlsx',
                pdf: 'pdf',
                clipboard: 'clipboard',
            }
        }
    },

    modules: {
        financial: {
            movements: {
                entry: 'entry',
                exit: 'exit',
                badges: {
                    partialDebit: 'Débito parcial',
                    noBalance: 'Débito acima de saldo',
                },
                dialogs: {
                    confirmationAddInitialBalanceDataObject: {
                        title: 'Atenção',
                        message: 'Se você prosseguir todas as movimentações atuais será excluídas e uma movimentação inicial será criada, deseja prosseguir?',
                    },
                    confirmationResetBalanceDataObject: {
                        title: 'Atenção',
                        message: 'Todas as movimentações para este grupo serão excluídas e o saldo atual será definido para R$ 0.00, deseja prosseguir?',
                    },
                    actions: {
                        yes: 'yes',
                        no: 'no',
                        cancel: 'cancel',
                    }
                },
            },
            transactionCompensation: {
                compensated: 'compensated',
                toCompensate: 'to_compensate'
            },
            entries: {
                receipts:{
                    dialogs: {
                        confirmationDeleteNoProcessedDataObject: {
                            title: 'Atenção',
                            message: 'Tem certeza que deseja excluir essa entrada não processada?',
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                            cancel: 'cancel',
                        }
                    },
                    alerts: {

                    }
                },
                consolidation:{
                    dialogs: {

                    },
                    alerts: {

                    }
                },
                cults:{
                    dialogs: {
                        confirmationSaveCultConst: {
                            title: 'Atenção',
                            message: 'Antes de registrar ou editar um culto, certifique-se de que todos os dados estão corretamente preenchidos e refletem as entradas obtidas, deseja prosseguir?',
                        },
                        confirmationDeleteCultConst: {
                            title: 'Atenção',
                            message: 'Tem certeza que deseja excluir este culto? Todas as entradas vinculadas (dízimos, ofertas e designadas) também serão excluídas.',
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                            cancel: 'cancel',
                        }
                    },
                    alerts: {

                    }
                },
                consolidations:{
                    dialogs: {
                        confirmationConsolidationConst: {
                            title: 'Atenção',
                            message: 'A consolidação deste mês não permitirá que novas entradas sejam incluídas nele, deseja realmente consolidar este mês?',
                        },
                        confirmationReopenConsolidationConst: {
                            title: 'Atenção',
                            message: 'Esta ação irá reabrir o mês e novas entradas poderão ser inseridas nele, deseja realmente reabrir este mês?',
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                            cancel: 'cancel',
                        }
                    },
                    alerts: {

                    }
                },
                entries: {
                    dialogs: {
                        confirmationDeleteEntry: {
                            title: 'Atenção',
                            message: 'Tem certeza que deseja excluir esta entrada?',
                        },
                        confirmationEntryWithoutTither: {
                            title: 'Atenção',
                            message: 'Não foi informado o nome do dizimista nesta entrada, deseja salvar ou editar mesmo assim?',
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                            cancel: 'cancel',
                        }
                    },
                    alerts: {

                    },
                    entryTypes: {
                        tithes: 'tithes',
                        tithe: 'tithe',
                        offer: 'offer',
                        designated: 'designated',
                    },
                    transactionTypes: {
                        cash: 'cash',
                        pix: 'pix',
                    },
                },

            },
            exits: {
                payments: {
                    dialogs: {
                        confirmationDeletePaymentItem: {
                            title: 'Atenção',
                            message: 'Deseja realmente excluir esse item de pagamento?',
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                        }
                    },
                    alerts: {

                    },
                    transactionTypes: {
                        bankSlip: 'bank_slip',
                        pix: 'pix',
                    },
                    exitsTypes: {
                        payments: 'payments',
                        transfer: 'transfer',
                        ministerialTransfer: 'ministerial_transfer',
                        contributions: 'contributions',
                    },
                },
                exitsTypes: {
                    payments: 'payments',
                    transfer: 'transfer',
                    ministerialTransfer: 'ministerial_transfer',
                    contributions: 'contributions',
                    purchase: 'purchase',
                },
                receipts:{
                    dialogs: {
                        confirmationDeleteNoProcessedDataObject: {
                            title: 'Atenção',
                            message: 'Tem certeza que deseja excluir essa saída não processada?',
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                            cancel: 'cancel',
                        }
                    },
                    alerts: {

                    }
                },
                purchases: {
                    dialogs: {
                        confirmationDeletePurchaseDataObject: {
                            title: 'Atenção',
                            message: 'Está compra será removida completamente, deseja realmente excluir esta compra?',
                        },
                        confirmationPostponePurchaseDataObject: {
                            title: 'Mudar fatura',
                            message: 'Deseja que essa compra seja exibida a partir da próxima fatura?',
                        },
                        warningMessages: {
                            groupDebitWithGroupName: 'Atenção: esta compra foi debitada do saldo do grupo "{groupName}". Ao excluí-la, o valor será restaurado ao saldo do grupo.',
                            groupDebitWithoutGroupName: 'Atenção: esta compra foi debitada do saldo do grupo. Ao excluí-la, o valor será restaurado ao saldo do grupo.',
                        },
                    },
                    alerts: {
                        deleteSuccess: 'Compra excluída com sucesso!',
                        deleteError: 'Erro ao excluir a compra',
                        postponeSuccess: 'Compra movida para a próxima fatura com sucesso!',
                        postponeError: 'Erro ao mover a compra',
                    },
                    actions: {
                        yes: 'yes',
                        no: 'no',
                        cancel: 'cancel',
                    }
                },
            },
            accountsCards: {
                accounts: {
                    files: {
                        dialogs: {
                            confirmationDeleteFileDataObject: {
                                title: 'Atenção',
                                message: 'Tem certeza que deseja excluir este arquivo de extrato?',
                            },
                            actions: {
                                yes: 'yes',
                                no: 'no',
                                cancel: 'cancel',
                            }
                        },
                    },
                },
                dialogs: {
                    confirmationDeleteCardDataObject: {
                        title: 'Atenção',
                        message: 'Ao excluir este cartão de crédito não será mais possível registrar novas compras para ele, mas as compras em andamento serão exibidas no sistema, deseja prosseguir?',
                    },
                    actions: {
                        yes: 'yes',
                        no: 'no',
                        cancel: 'cancel',
                    }
                },
            },
            reports: {
                entries: {
                    dialogs: {
                        confirmationGenerateReportConst: {
                            title: 'Atenção',
                            messages: {
                                monthlyReceipts: 'Este relatório entrará em uma fila de processamento, em breve ele estará disponível, deseja prosseguir?',
                                monthlyEntries: 'O processamento deste relatório levará um pouquinho de tempo, enquanto isso você pode utilizar normalmente o Atos8, deseja prosseguir?',
                                quarterlyEntries: 'O processamento deste relatório levará um pouquinho de tempo, enquanto isso você pode utilizar normalmente o Atos8, deseja prosseguir?',
                            },
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                            cancel: 'cancel',
                        }
                    },
                    alerts: {
                        selectEntryType: 'Informa ao menos um tipo de entrada!',
                        selectMonth: 'Informe ao menos 1 mês para iniciar a geração deste relatório!',
                        errorForm: 'Erro de prenchimento do formulário!',
                    },
                    reportName: {
                        monthlyReceipts: 'monthly_receipts',
                        monthlyEntries: 'monthly_entries',
                        quarterlyEntries: 'quarterly_entries',
                    },
                    reportStatus: {
                        toProcess: 'to_process',
                        inProgress: 'in_progress',
                        done: 'done',
                        error: 'error',
                        noData: 'no_data',
                    },
                },
                exits: {
                    dialogs: {
                        confirmationGenerateReportConst: {
                            title: 'Atenção',
                            messages: {
                                monthlyReceipts: 'Este relatório entrará em uma fila de processamento, em breve ele estará disponível, deseja prosseguir?',
                                monthlyEntries: 'O processamento deste relatório levará um pouquinho de tempo, enquanto isso você pode utilizar normalmente o Atos8, deseja prosseguir?',
                                monthlyExits: 'O processamento deste relatório levará um pouquinho de tempo, enquanto isso você pode utilizar normalmente o Atos8, deseja prosseguir?',
                                quarterlyEntries: 'O processamento deste relatório levará um pouquinho de tempo, enquanto isso você pode utilizar normalmente o Atos8, deseja prosseguir?',
                            },
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                            cancel: 'cancel',
                        }
                    },
                    alerts: {
                        selectEntryType: 'Informa ao menos um tipo de saída!',
                        selectMonth: 'Informe ao menos 1 mês para iniciar a geração deste relatório!',
                        errorForm: 'Erro de prenchimento do formulário!',
                    },
                    reportName: {
                        monthlyReceipts: 'monthly_receipts',
                        monthlyEntries: 'monthly_exits',
                        monthlyExits: 'monthly_exits',
                    },
                    reportStatus: {
                        toProcess: 'to_process',
                        inProgress: 'in_progress',
                        done: 'done',
                        error: 'error',
                        noData: 'no_data',
                    },
                },
                balances: {
                    dialogs: {
                        confirmationGenerateReportConst: {
                            title: 'Atenção',
                            messages: {
                                generalBalances: 'Este relatório entrará em uma fila de processamento, em breve ele estará disponível, deseja prosseguir?',
                                monthlyEvolution: 'O processamento deste relatório levará um pouquinho de tempo, enquanto isso você pode utilizar normalmente o Atos8, deseja prosseguir?',
                            },
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                            cancel: 'cancel',
                        }
                    },
                    alerts: {
                        selectMonth: 'Informe ao menos 1 mês para iniciar a geração deste relatório!',
                        errorForm: 'Erro de prenchimento do formulário!',
                    },
                    reportName: {
                        generalBalances: 'general_balances',
                        monthlyEvolution: 'monthly_evolution',
                    },
                    reportStatus: {
                        toProcess: 'to_process',
                        inProgress: 'in_progress',
                        done: 'done',
                        error: 'error',
                        noData: 'no_data',
                    },
                },
                purchases: {
                    dialogs: {
                        confirmationGenerateReportConst: {
                            title: 'Atenção',
                            messages: {
                                monthlyReceipts: 'Este relatório entrará em uma fila de processamento, em breve ele estará disponível, deseja prosseguir?',
                                monthlyPurchases: 'O processamento deste relatório levará um pouquinho de tempo, enquanto isso você pode utilizar normalmente o Atos8, deseja prosseguir?',
                            },
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                            cancel: 'cancel',
                        }
                    },
                    alerts: {
                        selectMonth: 'Informe ao menos 1 mês para iniciar a geração deste relatório!',
                        errorForm: 'Erro de prenchimento do formulário!',
                        reportInProgress: 'Este relatório encontra-se em processamento, aguarde até acessar seus dados!',
                        reportNoData: 'Nenhum relatório foi gerado, pois os filtros informados não encontraram dados',
                        reportError: 'Houve um erro na geração desse relatório, tente mais tarde',
                    },
                    reportName: {
                        monthlyReceipts: 'monthly_receipts_purchase',
                        monthlyPurchases: 'monthly_purchases',
                    },
                    reportStatus: {
                        toProcess: 'to_process',
                        inProgress: 'in_progress',
                        done: 'done',
                        error: 'error',
                        noData: 'no_data',
                    },
                },
                summary: {
                    dialogs: {
                        confirmationGenerateReportConst: {
                            title: 'Atenção',
                            messages: {
                                monthlySummary: 'Será gerado um relatório consolidado mensal com todos os totalizadores. Este relatório entrará em uma fila de processamento, deseja prosseguir?',
                            },
                        },
                        actions: {
                            yes: 'yes',
                            no: 'no',
                            cancel: 'cancel',
                        }
                    },
                    alerts: {
                        selectMonth: 'Informe ao menos 1 mês para iniciar a geração deste relatório!',
                        errorForm: 'Erro de preenchimento do formulário!',
                        reportInProgress: 'Este relatório encontra-se em processamento, aguarde até acessar seus dados!',
                        reportNoData: 'Nenhum relatório foi gerado, pois os filtros informados não encontraram dados',
                        reportError: 'Houve um erro na geração desse relatório, tente mais tarde',
                    },
                    reportName: {
                        monthlySummary: 'monthly_summary',
                    },
                    reportStatus: {
                        toProcess: 'to_process',
                        inProgress: 'in_progress',
                        done: 'done',
                        error: 'error',
                        noData: 'no_data',
                    },
                },
            }
        },
        secretary: {
            membership: {
                dialogs: {
                    confirmationActivatedMemberDataObject: {
                        title: 'Atenção',
                        message: 'Tem certeza que deseja alterar o status deste membro?',
                    },
                    actions: {
                        yes: 'yes',
                        no: 'no',
                        cancel: 'cancel',
                    }
                },
            },
            documents: {
                dialogs: {
                    confirmationDeleteMinuteDataObject: {
                        title: 'Excluir ata',
                        message: 'Tem certeza que deseja excluir essa ata? Essa ação não poderá ser desfeita.',
                    },
                }
            }
        },
        ecclesiastical: {
            divisions: {
                ministries: 'ministries',
                departures: 'departures',
                organizations: 'organizations',
                events: 'events',
                projects: 'projects',
                campaigns: 'campaigns',
                education: 'education'
            },
            groups: {
                export: {
                    types: {
                        xlsx: 'xlsx',
                        pdf: 'pdf',
                        clipboard: 'clipboard',
                    }
                }
            }
        },
        user: {
            account: {
                dialogs: {
                    confirmationChangeEmailDataObject: {
                        title: 'Atenção',
                        message: 'A alteração só será concluída após você responder a confirmação que enviaremos para este email, até lá você continua a acessar com o email atual, Tem certeza que deseja alterar o email desta conta?',
                    },
                    confirmationChangePasswordDataObject: {
                        title: 'Atenção',
                        message: 'Você deverá informar a nova senha na próxima autenticação, deseja prosseguir?',
                    },
                    actions: {
                        yes: 'yes',
                        no: 'no',
                        cancel: 'cancel',
                    }
                }
            },
            billing: {
                dialogs: {
                    confirmationDeletePaymentMethodDataObject: {
                        title: 'Excluir cartão',
                        message: 'Tem certeza que deseja excluir este cartão?',
                    },
                    actions: {
                        yes: 'yes',
                        no: 'no',
                    }
                }
            }
        }
    }
}
